import buildUrl from 'modules/core/lib/buildUrl'

export const buildAvatarUrl = (
  avatar?: { url?: string | null; id?: string | null } | null
): string => {
  if (avatar?.url) return buildUrl(avatar.url)
  if (avatar?.id) return buildUrl(avatar.id)
  return ''
}
